<template>
    <app-k-v
        titulo="Último Acesso"
        :md="3"
        :lg="2"
        :xl="1"
        :dado="
            ultimoAcesso
                ? `${$maskDateTime(ultimoAcesso)} (${$moment(
                      ultimoAcesso
                  ).fromNow()})`
                : 'SEM ACESSO REGISTRADO'
        "
    ></app-k-v>
</template>

<script>
export default {
    props: {
        ultimoAcesso: {
            type: Object
        }
    }
}
</script>
